export default {
    name: 'Contribution',

    props: {
        operation: {
            type: Object,
            required: true
        }
    }
};
